import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import List from './List';
import EmptyScreen from './EmptyScreen';
import Button from '../../common/Button';
import * as Date from '../../utils/date';
import * as API from '../../core/api';
import { requestDataIfNeeded } from '../../user/duck';

import ReactSVG from 'react-svg';
import confirmInfoEmpty from '../../img/confirm-info-empty-screen.svg';

const handleNoProjectsConfirm = (requestUserDataIfNeeded) =>
  API.post('users/me/confirm-up-to-date')
    .then(requestUserDataIfNeeded) // Refresh user.
    // Extremely basic error handling... :-)
    .catch((error) => alert(JSON.stringify(error)));

const renderConfirm = (userActiveProjects, t, requestDataIfNeeded) => {
  if (userActiveProjects.length) {
    return <List userActiveProjects={userActiveProjects} />;
  }

  return (
    <React.Fragment>
      <h3>{t('manageUpdates.confirmNoUpdates.title')}</h3>
      <p className="u-weight-light">
        {t('manageUpdates.confirmNoUpdates.note')}
      </p>
      <div className="u-margin-bottom-large">
        <Button
          styleType="simple"
          onClick={() => handleNoProjectsConfirm(requestDataIfNeeded)}
        >
          {t('manageUpdates.confirmNoUpdates.btnTitle')}
        </Button>
        <Link
          to="/my-profile"
          className="c-btn c-btn--primary u-margin-left-mini"
        >
          {t('general.goProfile')}
        </Link>
      </div>
      <ReactSVG
        src={confirmInfoEmpty}
        svgClassName="u-margin-vertical-huge u-img-responsive"
      />
    </React.Fragment>
  );
};

const Screen = ({
  userActiveProjects,
  shouldDisplayConfirmDialog,
  notYetTheTime,
  daysToShowingSection,
  requestDataIfNeeded,
  t,
}) => (
  <React.Fragment>
    {/* Confirm Current Projects - Up-to-date */}
    <div className="u-text-center">
      {notYetTheTime ? (
        <EmptyScreen
          notYetTheTime={notYetTheTime}
          daysToShowingSection={daysToShowingSection}
        />
      ) : shouldDisplayConfirmDialog ? (
        renderConfirm(userActiveProjects, t, requestDataIfNeeded)
      ) : (
        <EmptyScreen
          notYetTheTime={notYetTheTime}
          daysToShowingSection={daysToShowingSection}
        />
      )}
    </div>
    {/* Confirm Current Projects - Confirmation */}
  </React.Fragment>
);

const mapStateToProps = ({ user, workspace }) => {
  const upToDateConfirmedAt = user.data && user.data.upToDateConfirmedAt;
  const daysToNextUpdate = Date.getDaysToDate(workspace.data.nextUpdate);

  const shouldDisplayConfirmDialog =
    !upToDateConfirmedAt || Date.isOlderThanDays(upToDateConfirmedAt, 8);

  return {
    userActiveProjects:
      user.data &&
      user.data.projects.filter(({ status }) => status === 'ACTIVE'),
    upToDateConfirmedAt,
    shouldDisplayConfirmDialog,
    notYetTheTime: daysToNextUpdate > 7,
    daysToShowingSection: daysToNextUpdate - 7,
  };
};

const mapDispatchToProps = { requestDataIfNeeded: requestDataIfNeeded };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/updates/user-confirm/Screen.js